import { useAppSelector } from '@/hooks/redux';

import { selectLoggedInUser } from '@/redux/auth/selectors';
import { selectConfigsState } from '@/redux/configs';

import { DesktopOnly } from '../Layout/Responsive';
import { LoggedInUserButton } from '../User/LoggedInUserButton';

import {
  CenterSlot,
  Container,
  HeaderIcon,
  LeftSlot,
  RightSlot,
} from './Header.styled';

export function Header() {
  const user = useAppSelector(selectLoggedInUser);
  const { headerLogoIconOnDark, headerLogoIconSx } =
    useAppSelector(selectConfigsState);

  if (!user) {
    return null;
  }

  return (
    <DesktopOnly>
      <Container>
        <LeftSlot>
          <HeaderIcon
            name={headerLogoIconOnDark ?? 'logo'}
            size={44}
            {...(headerLogoIconSx ? { sx: headerLogoIconSx } : {})}
          />
        </LeftSlot>
        <CenterSlot></CenterSlot>
        <RightSlot>
          <LoggedInUserButton user={user} />
        </RightSlot>
      </Container>
    </DesktopOnly>
  );
}
